import { Table } from "react-bootstrap";
import "./usuariosTable.css";
import { UsuariosRow } from "./UsuariosRow";
import { UsuarioI } from "interfaces/Usuario";
import { ReactNode } from "react";

interface Props {
  elementos: UsuarioI[];
  renderActions?: (elemento: UsuarioI) => ReactNode;
}

export const UsuariosTable = ({ elementos = [], renderActions }: Props) => {
  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>Nombre</th>
            <th>Mail</th>
            <th>Rol</th>
            <th>Alta de rol</th>
            {renderActions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <UsuariosRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-center table-error-message">
                <p>
                  <b>No hay usuarios para visualizar.</b> Para poder visualizar
                  usuarios debes <br /> seleccionar el botón agregar «Nuevo
                  usuario».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
